module.exports = __webpack_public_path__ + "static/img/jiankong.d8bd12e1.png";